<template>
  <div id="applicationManager">
    <div
      :class="{ 'wrap-content-long' : !is_sidebar_minimized }"
      class="wrap-content"
    >
      <!-- Header -->
      <div class="header-page header-page-group">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <img
              class="back-to-list"
              src="@/assets/icon/arrow-left.svg"
              @click="$router.go(-1)"
            >
            <div
              v-if="isLoading"
              class="skeleton-box"
              style="width: 100px; height: 30px; margin-bottom: 0 !important;"
            />
            <h3
              v-else
              class="application-name">
              {{ groupName }}
            </h3>
          </div>
          <i
            id="popover-config-menu"
            class="fa fa-ellipsis-v fa-lg popover-config"
          />
        </div>

        <!-- Tabs -->
        <div class="tabs">
          <div class="tab-list tab-active">GENERAL</div>
        </div>
      </div>

      <!-- Content -->
      <div class="application-content">
        <!-- Properties -->
        <div
          class="card-content mb-4"
          style="width: 80%;"
        >
          <p class="card-title">Properties</p>

          <!-- Loading -->
          <div v-if="isLoading">
            <div
              class="skeleton-box"
              style="height: 40px;"
            />
            <div
              class="skeleton-box"
              style="height: 120px;"
            />
          </div>

          <div v-else>
            <b-form-group :class="{'error-input' : $v.group.name.$error}">
              <label> Group Name </label>
              <j-input
                v-model="$v.group.name.$model"
                placeholder="Enter group name here"
              />
            </b-form-group>

            <b-form-group :class="{'error-input' : $v.group.description.$error}">
              <label> Description </label>
              <j-textarea
                v-model="$v.group.description.$model"
                :disabled="false"
                placeholder="Enter group description here"
              />
            </b-form-group>

            <div class="d-flex justify-content-end">
              <button
                class="button-blue"
                @click="updateGroup"
              >
                Update
              </button>
            </div>
          </div>
        </div>

        <!-- Application -->
        <div
          class="card-content"
          style="width: 80%;"
        >
          <p class="card-title">Application</p>

          <!-- Loading -->
          <jLoadingTable v-if="isLoading" />

          <v-client-table
            v-show="!isLoading"
            :data="dataApps"
            :columns="columns"
            :options="tableOptions"
            class="jTable group-application-table">
            <div
              slot="beforeFilter"
              class="custom-search">
              <b-form inline>
                <b-button
                  class="btn grey btn-import-form m__r--5"
                  @click="isModalAppOpen(true)">
                  <i class="fa fa-plus fa-lg"/> Add
                </b-button>
                <b-form
                  inline
                  @keypress.13.prevent="filter(filterData)">
                  <j-select
                    v-model="selectType"
                    :options="optionsSearch"
                    placeholder="Filter By"
                    class="m__r--5"/>
                  <b-form-input
                    v-model="filterData"
                    placeholder="Search"
                    style="width: 250px; height: 35px"/>
                </b-form>
              </b-form>
            </div>

            <div
              slot="id"
              slot-scope="props">
              {{ props.row.id }}
            </div>

            <div
              slot="icon"
              slot-scope="props">
              <img
                v-if="props.row.icon"
                :src="props.row.icon"
                width="32">
            </div>

            <div
              slot="name"
              slot-scope="props">
              {{ props.row.name }}
            </div>

            <div
              slot="delete"
              slot-scope="props">
              <i
                class="fa fa-trash fa-lg cursor-pointer"
                @click="deleteMapping(props.row.id)"/>
            </div>
          </v-client-table>
        </div>
      </div>
    </div>

    <b-popover
      ref="configPopoverRef"
      target="popover-config-menu"
      placement="left">
      <div
        class="form-ui-opt"
        @click="deleteGroup">
        Delete Group
      </div>
    </b-popover>

    <b-modal
      ref="appModal"
      class="mod-form modal-app-type"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <j-modal-mapping-apps-group
        @modal-open="isModalAppOpen"
        @data-created="getGroupApplicationList"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
// Components
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jModalMappingAppsGroup from '@/views/setting/jModalMappingAppsGroup';

export default {
  validations() {
    return {
      group: {
        name: { required },
        description: { },
      },
    };
  },

  components: {
    jLoadingTable,
    jModalMappingAppsGroup,
  },

  data() {
    return {
      isLoading: true,
      dataApps: [],
      dataGroup: null,
      groupName: null,
      group: {
        name: null,
        description: null,
      },
      columns: ['id', 'icon', 'name', 'delete'],
      tableOptions: {
        headings: {
          id: 'ID',
          icon: 'LOGO',
          name: 'NAME',
          delete: '',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },
      filterData: '',
      selectType: 'name',
      optionsSearch: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['group_applications_list', 'is_sidebar_minimized']),
  },

  watch: {
    group_applications_list(val) {
      this.dataGroup = val.find(group => group.id === Number(this.$route.params.groupId));
      if (this.dataGroup) {
        this.groupName = this.dataGroup.name;
        this.group.name = this.dataGroup.name;
        this.group.description = this.dataGroup.description;

        this.dataApps = this.dataGroup.application;
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getGroupApplicationList();
  },

  methods: {
    ...mapActions('jStoreSetting', [
      'actionGetGroupApplicationsDetail',
      'actionUpdateGroupApplication',
      'actionDeleteGroupApplication',
      'actionDeleteGroupRelation',
    ]),

    getGroupApplicationList() {
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetGroupApplicationsDetail(param);
    },

    isModalAppOpen(val) {
      if (val) this.$refs.appModal.show();
      else this.$refs.appModal.hide();
    },

    filter(val) {
      this.dataApps = this.dataGroup.application.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    async updateGroup() {
      this.$v.group.$touch();
      if (!this.$v.group.$error) {
        const groupId = this.dataGroup.id;
        const param = {
          name: this.group.name,
          description: this.group.description,
        };
        const res = await this.actionUpdateGroupApplication({ groupId, param });
        if (res.error) {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', res.message);
        } else {
          this.groupName = this.group.name;
        }
      }
    },

    deleteGroup() {
      const name = this.group.name;

      this.$swal({
        title: 'Delete Group',
        html: `Are you sure to delete Group "<span style="font-family: Poppins-Medium; font-size: 18px;">${name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const res = await this.actionDeleteGroupApplication(this.dataGroup.id);
          if (!res.error) this.$router.push('/application-manager');
        }
      });
    },

    deleteMapping(appId) {
      const text = 'Are you sure to delete?';
      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            application_id: appId,
            group_application_id: this.dataGroup.id,
          };
          const res = await this.actionDeleteGroupRelation(param);
          if (!res.error) {
            this.getGroupApplicationList();
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/jAppManagerDetailGroup.vue